import { Text, VStack, Icon, Box } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { AlertTriangleIcon } from 'lucide-react';

export const OrphanSeatsContent = () => {
  return (
    <VStack height='100%' align='center' justify='center' spacing={4} p={6} textAlign='center'>
      <Box
        w={12}
        h={12}
        borderRadius='full'
        bg='orange.50'
        border='2px solid'
        borderColor='orange.200'
        display='flex'
        alignItems='center'
        justifyContent='center'
      >
        <Icon as={AlertTriangleIcon} boxSize={6} color='orange.500' />
      </Box>

      <VStack spacing={2}>
        <Text variant='bodyLargeSemiBold' color='orange.600'>
          <FormattedMessage defaultMessage='Cannot leave single seats' id='seats.orphanError' />
        </Text>
        <Text color='dark.D500' variant='bodySmallRegular' maxW='280px' lineHeight='1.5'>
          <FormattedMessage
            defaultMessage='Please select seats together to avoid leaving isolated single seats'
            id='seats.invalidSelection'
          />
        </Text>
      </VStack>
    </VStack>
  );
};
